import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from '@vds/grids';
import { ModalBody, ModalFooter } from '@vds/modals';
import { TitleLockup } from '@vds/type-lockups';

import PageTitle from './pageTitle';
import { crossSiteCheckUrl, isPreorder, getSession, setSession, isSequentialFlow } from '../../../common/Helpers/index';

import { VDSModal as Modal } from '../../../common/Modal/VDSModal';
import { goToProcessStep } from '../../../../redirection';
import logger from '../../../common/ErrorBoundary/logger_new';
import { getAccMgrUrl } from '../../../../services/UrlMapperService';
import { saveItemToStore } from '../../../../utils/sessionStorage';
import { Title } from '../../../common/Typography/index';

import { store } from '../../../../configureStore';
import { Margin } from '../../../common/styles';

export default class RegistrationInfo extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      timeOutModal: false,
      interval: '',
    };
  }

  componentDidMount() {
    // skipping registration page for shell account registration
    if (((this.props?.isUniversalProfileCreated || this.props?.isEmailExists) && this.props?.isCradleFlow) || isSequentialFlow()) {
      goToProcessStep(this.props.currentView, this.props.history);
      return;
    }
    const orderSubmitted = getSession('OrderSubmitted');
    const ordreg = getSession('ordreg');
    if (ordreg !== 'Y') {
      setSession('ordreg', 'Y');
    }
    if (orderSubmitted === 'Y') {
      goToProcessStep(this.props.currentView, this.props.history);
    } else {
      const { registrationTimeoutNonProd, registrationTimeoutProd } = window.vzFlags || {};
      let timeOutValue = registrationTimeoutNonProd;
      if (window.location.hostname === 'www.verizon.com') {
        timeOutValue = parseInt(registrationTimeoutProd);
      }
      this.updateTimer(timeOutValue);
    }
    // --> fortify issue is existed, uncommented the code for time being
    if (this.props.registrationDetails === null || this.props.registrationDetails === undefined) {
      const errorLog = {
        json: true,
        eventType: 'BLOCKER',
        message: 'GENERIC_ERROR_PAGE',
        note: 'from RegistrationInfo component',
        // networkError: {
        //   error: apiResponse,
        //   response: apiResponse.data.errors || null,
        // },
      };
      logger(errorLog);
    }
    store.dispatch({ type: 'UPDATE_API_STATUS', response: 'IN_PROGRESS' });
  }

  componentDidUpdate() {
    if (!this.state.invokeTagging && this.props.apiStatus === 'COMPLETED') {
      this.props.invokeTaggingAPI();
      this.setState({ invokeTagging: true });
    }
    const loginform = document.getElementById('loginForm');
    const targetURL = `${window.location.origin}/sales/home/confirmation.html?newRegistrationSucess=true`;
    const amRedirectionUrl = crossSiteCheckUrl(
      `${`${getAccMgrUrl()}`}/account/register/guest/createprofile?mode=i&targetURL=${encodeURIComponent(targetURL)}`,
    );

    loginform.action = amRedirectionUrl;
    loginform.style.display = 'none';
    loginform.submit();
  }

  updateTimer = (timeOutValue) => {
    clearInterval(this.state.interval);
    this.props.getCartDataFromApi('registration');
    this.setState({
      interval: setInterval(() => {
        this.setState({ timeOutModal: true });
      }, timeOutValue),
    });
  };

  redirectTo = () => {
    saveItemToStore('regSkip', 'Y');
    this.setState(
      {
        timeOutModal: false,
      },
      () => {
        // window.location.href = window.location.origin + '/sales/home/confirmation.html';
        goToProcessStep(this.props.currentView, this.props.history);
      },
    );
  };

  closeModal = () => {
    this.setState({
      timeOutModal: false,
    });
    const { registrationTimeoutNonProd, registrationTimeoutProd } = window.vzFlags || {};
    let timeOutValue = registrationTimeoutNonProd;
    if (window.location.hostname === 'www.verizon.com') {
      timeOutValue = parseInt(registrationTimeoutProd);
    }
    this.updateTimer(timeOutValue);
  };

  modalChanged = (state) => {
    if (!state) {
      this.setState({
        timeOutModal: false,
      });
    }
  };

  render() {
    const targetURL = `${window.location.origin}/sales/home/confirmation.html?newRegistrationSucess=true`;
    const amRedirectionUrl = crossSiteCheckUrl(
      `${`${getAccMgrUrl()}`}/account/register/guest/createprofile?mode=i&targetURL=${encodeURIComponent(targetURL)}`,
    );
    const { orderNumber, emailId, locationCode } = this.props.registrationDetails || {};
    return (
      <Row>
        <Col colSizes={{ desktop: 8, tablet: 4, mobile: 4 }}>
          <PageTitle pageInfo={this.props} />
          {/* <Col> */}

          <Col className="RegTitle" style={{ paddingLeft: '0px' }} colSizes={{ desktop: 8, tablet: 4, mobile: 4 }}>
            <Title size="medium" primitive="h2">
              {' '}
              {this.props.registrationPageCreateHeading}
            </Title>
          </Col>
          <Row className="regPageDetails">
            {isPreorder() ? (
              <Col id="regPageDetails" dangerouslySetInnerHTML={{ __html: this.props.registrationPageDetailsPreorder }} />
            ) : (
              <Col id="regPageDetails" dangerouslySetInnerHTML={{ __html: this.props.registrationPageDetails }} />
            )}
          </Row>
          {/* </Col> */}
          <Col colSizes={{ desktop: 6, tablet: 4, mobile: 4 }}>
            <Row>
              {/* <iframe src={aemIframeUrl} id="aemRegFrame" className="onlyTopMargin margin30" width="120%" height="400px" /> */}
              <form id="loginForm" target="myFrame" method="POST" action={amRedirectionUrl}>
                <input type="text" name="locationCode" value={locationCode} />
                <input type="text" name="orderNumber" value={orderNumber} />
                <input type="text" name="orderingEmail" value={emailId} />
                <input type="text" name="targetURL" value={targetURL} />
                <input type="submit" />
              </form>
              <iframe
                name="myFrame"
                src="#"
                title="aemForm"
                style={{
                  minHeight: '100vh',
                  height: '100%',
                  width: '100%',
                  border: 'none',
                }}
              >
                {' '}
                Your browser does not support inline frames.
              </iframe>
            </Row>
          </Col>

          {this.state.timeOutModal && (
            <Modal ariaLabel="Skip Register Modal" opened={this.state.timeOutModal} onOpenedChange={this.modalChanged} disableOutsideClick>
              <ModalBody>
                <Margin bottom="20px">
                  <TitleLockup
                    data={{
                      title: {
                        bold: false,
                        size: 'titleMedium',
                        children: this.props.overlayHeading,
                      },
                      subtitle: {
                        size: 'bodyLarge',
                        color: 'secondary',
                        children: this.props.overlaySubheading,
                      },
                    }}
                  />
                </Margin>
              </ModalBody>

              <ModalFooter
                buttonData={{
                  primary: {
                    width: '120%',
                    children: this.props.buttonRegistration,
                    onClick: () => this.closeModal(),
                  },
                  close: {
                    width: '80%',
                    children: this.props.buttonSkip,
                    onClick: () => this.redirectTo(),
                  },
                }}
              />
            </Modal>
          )}
        </Col>
      </Row>
    );
  }
}

RegistrationInfo.propTypes = {
  overlayHeading: PropTypes.string,
  buttonSkip: PropTypes.string,
  buttonRegistration: PropTypes.string,
  getCartDataFromApi: PropTypes.func,
  overlaySubheading: PropTypes.string,
  registrationPageDetails: PropTypes.string,
  registrationPageCreateHeading: PropTypes.string,
  registrationDetails: PropTypes.object,
  currentView: PropTypes.object,
  history: PropTypes.object,
  registrationPageDetailsPreorder: PropTypes.string,
  invokeTaggingAPI: PropTypes.func,
  apiStatus: PropTypes.string,
  isUniversalProfileCreated: PropTypes.bool,
  isEmailExists: PropTypes.bool,
  isCradleFlow: PropTypes.bool,
};
